import { render, staticRenderFns } from "./CambiarPassword.vue?vue&type=template&id=1d810a2b&scoped=true"
import script from "./CambiarPassword.vue?vue&type=script&lang=js"
export * from "./CambiarPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d810a2b",
  null
  
)

export default component.exports